import getFromCdn from '../getFromCdn';

export default (src: string) =>
  new RegExp('http').test(src) ? src : getFromCdn(src);
